import React, { useContext, useEffect, useState } from "react";
// import "./LoanDetailsMemberView.css";
import InputForm, { AutoCompleteValue } from "../../../Components/InputForm/InputForm";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { useLocation, useSearchParams } from "react-router-dom";
import { APICall } from "../../../Helpers/Network/APICalls";
import {
  CommonDropdownData,
  GetLoanRepaymentPaymentDetails,
  InsertLoanRepaymentPaymentDetails,
  documentDetails,
  getConfigValues,
  insertLoanPaymentDetailsData,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { Alert, IconButton, Tooltip, Typography } from "@mui/material";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import { Modal, Table } from "react-bootstrap";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";
import { useNavigate } from "react-router-dom";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import DateForm from "../../../Components/DateForm/DateForm";
import moment from "moment";
import OverflowTip from "../../../Components/OverflowToolTip/OverflowToolTip";
import { DATE_DISPLAY_FORMAT } from "../../../Helpers/Constants/Constants";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { GenericMasterType } from "../../../Helpers/Enums/Enum";
import { getFormattedCurrencyValue, getFormattedCurrencyValueWithSymbol } from "../../../Helpers/Common";
import { LoanRepayment } from "../../../Helpers/Enums/ApplicationStatus";
import ImageViewer from "../../../Components/ImageViewer/ImageViewer";
import { downloadBlob } from "../../../Helpers/Common/BlobHelper";
import LoanRepaymentVerifyModal from "../LoanRepaymentVerifyModal/LoanRepaymentVerifyModal";
import { VerifyModalModules } from "../Enums/VerifyModalModules";
import { FaLaptopHouse } from "react-icons/fa";

interface DashboardDataItem {
  AccountHolderName: string;
  BankName: any;
  BankID: any;
  Amount: string;
  TransactionDate: Date;
  TransactionRefNumber: string;
  TypesOfTransactionName: string;
  TypesOfTransactionId: number;
  StatusTitle: string;
  Branch: string;
  Id: string;
  ChequeDocId?: number;
  ChequeDocUrl?: string;
  ChequeName?: string;
  IsActive?: boolean;
}

const PaymentDetails = (props) => {
  const { LoanRequestId, LoanRepaymentId, Status, RepaymentAmount } = props;
  const { state } = useLocation();
  const navigate = useNavigate();
  const context = getContext();

  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const showLoanRepaymentVerifyModal = Boolean(anchorEl);
  const [AccHolderName, setAccHolderName] = useState<any>();

  const [Amount, setAmount] = useState("");
  const [transctRefNumber, settransctRefNumber] = useState("");
  const [transcType, setTranscType] = useState<any>([]);
  const [bankName, setbankName] = useState<any>();
  const [transcDate, setTranscDate] = useState([]);
  const [transacTypeOption, settransacTypeOption] = useState([]);
  const [bankNameOption, setBankNameOption] = useState([]);
  const [branchName, setBranchName] = useState("");
  const [bankAsText, setBankAsText] = useState(false);
  const [bankNameTxt, setbankNameTxt] = useState("");
  const [id, setId] = useState(null);

  const [chqName, setchqName] = useState(null);
  const [chequeDocUrl, setChequeDocUrl] = useState(null);
  const [chequeDocId, setChequeDocId] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = React.useState<any>({});
  const [binaryDataChq, setBinaryChq] = useState(null);
  const [disable, setDisable] = useState(
    context?.CurrentRoleId === RoleEnum.InternalTeam ||
      (context?.CurrentRoleId === RoleEnum.Member &&
        ![LoanRepayment.LoanRepayment_MemberPaymentDetailsPending, LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestSentBack].includes(Status))
  );
  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardOverallData, setDashboardOverallData] = useState([]);
  const [paymttb, setpaymttb] = React.useState(0);
  const [showFields, setShowFields] = useState<boolean>(false);
  const [bankDetails, setBankDetails] = React.useState([
    { name: "accountname", label: "Account Name", value: "" },
    { name: "accountnumber", label: "Account Number", value: "" },
    { name: "bankname", label: "Bank Name", value: "" },
    { name: "ifsccode", label: "IFSC Code", value: "" },
  ]);

  const [formErrors, setFormErrors] = useState({});
  const [transArray, setTranArray] = useState([]);
  // [ // generic
  //   { value: "NEFT", label: "NEFT" },
  //   { value: "RTGS", label: "RTGS" },
  //   { value: "IMPS", label: "IMPS" },
  //   { value: "Cheque", label: "Cheque" },
  // ];

  const [bankArray, setBankArray] = useState([]);

  const [showImageViewer, setShowImageViewer] = useState<boolean>(false);
  const [images, setImages] = useState([]);
  const [imageIndex, setImageIndex] = useState<number>(null);
  const [tableRowIndex, setTableRowIndex] = useState<number>(null);
  const [isDataEdited, setIsDataEdited] = useState<boolean>(false);

  // [ // dropdownName :  "bankdetails"
  //   { value: "ICICI", label: "ICICI" },
  //   { value: "HDFC", label: "HDFC" },
  //   { value: "Axis", label: "Axis" },
  //   { value: "Other", label: "Other" },
  // ];

  const handleKeyPress = (event) => {
   
    const allowedKeys = /^[0-9]+$/;
    if (!event.key.match(allowedKeys)) {
      event.preventDefault();
    }
  };

  const onSubmitValidation = () => {
    let formErrorObj = {};
    if (!AccHolderName || AccHolderName === "") {
      formErrorObj["AccHolderName_isEmpty"] = "Account holder name can not be empty";
    }
    if (!bankName || bankName === "") {
      formErrorObj["bankName_isEmpty"] = "bank  name can not be empty";
    }
    if (bankName && bankName.label.toLowerCase() == "other" && (!bankNameTxt || bankNameTxt === "")) {
      formErrorObj["bankNameAsTxt_isEmpty"] = "bank  name can not be empty";
    }
    if (bankName && bankName.label.toLowerCase() == "other" && bankNameTxt) {
      const bankNameAlreadyPresent = bankArray.find((ba) => ba.label.toLowerCase().trim() == bankNameTxt.toLowerCase().trim());
      if (bankNameAlreadyPresent) {
        formErrorObj["bankNameAsTxt_isEmpty"] = "bank name should be unique";
      }
    }
    if (!transctRefNumber || transctRefNumber === "") {
      formErrorObj["transctRefNumber_isEmpty"] = "transction Reference Number can not be empty";
    }
    if (!Amount || Amount === "") {
      formErrorObj["Amount_isEmpty"] = "Amount can not be empty";
    }
    if ((Amount || Amount != "") && parseInt(Amount) <= 0) {
      formErrorObj["Amount_isEmpty"] = "Amount should be greater than 0";
    }
   
    if (!transcType || transcType == "" || transcType.length === 0) {
     
      formErrorObj["transcType_isEmpty"] = "Transaction type  can not be empty";
    }

    if (!transcDate || transcDate == null) {
      formErrorObj["transcDate_isEmpty"] = "Transaction Date  can not be empty";
    }
    if (!branchName || branchName === "") {
      formErrorObj["branchName_isEmpty"] = "Branch name  can not be empty";
    }
    setFormErrors(formErrorObj);
    return formErrorObj;
  };

  const onClickFunction = async (action: any) => {
    if (action === "Submit") {
      submitData();
     
      // const submittedRepaymntCount = localStorage.getItem("loanSettlementTabssubmitted");
      // const newCount = (parseInt(submittedRepaymntCount, 10) || 0) + 1;
      // setpaymttb(newCount);
      // localStorage.setItem("loanSettlementTabssubmitted", newCount.toString());

      // console.log("visitCount=" + newCount);
      // if (action === "Submit") {
      //   let formErrorObj = onSubmitValidation();
      //   let isEmpty = Object.values(formErrorObj).every((f) => {
      //     return f === "" || f === null || f === undefined;
      //   });
      //   if (isEmpty === true) {
      //     let param = {
      //       // Id: state.id != null || state.id != 0 ? state.id : 0,
      //       // CreatedDateUtc: moment(new Date()).format(moment.HTML5_FMT.DATETIME_LOCAL),
      //     };
      //     console.log(param);

      //     const insertData = await APICall(insertLoanPaymentDetailsData, param);

      //     if (insertData?.Data?.Status == ApiStatus.Error) {
      //       const errors = insertData?.Data?.Data;
      //       const errorComponent = Array.isArray(errors) ? <div dangerouslySetInnerHTML={{ __html: errors?.join("<br />") }} /> : errors;
      //       notify(1, errorComponent);
      //     } else if (insertData?.Status == ApiStatus.Error) {
      //       notify(1, insertData?.Data);
      //     }
      //   }
      // }
    } else if (action === "Cancel") {
      navigate(-1);
    }
  };

  const getBase64FromFilePromise = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (isFile(file) === true) {
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
      }
      reader.onerror = (error) => reject(error);
    });

  const getDropDownDataBankDetail = async () => {
    //showLoader();
    let requestParams = {
      dropdownName: "bankdetails",
    };

    const res = await APICall(CommonDropdownData, requestParams);
    if (res && res?.Data?.length > 0) {
      let options = res.Data;
      setBankArray(options);
    } else {
      setBankArray([]);
    }
    hideLoader();
  };
  const getTransDropDownDataApiCall = async () => {
    //showLoader();
    let requestParams = {
      dropdownName: "generic",
      GenericMasterTypeId: GenericMasterType.LOANREPAYMENT,
    };

    const res = await APICall(CommonDropdownData, requestParams);
    if (res && res?.Data?.length > 0) {
      let options = res.Data;
      setTranArray(options);
    } else {
      setTranArray([]);
    }
    hideLoader();
  };

  const removeRow = (rowIndex) => {
    const currentData = [...dashboardData];
    currentData.splice(rowIndex, 1);
    setDashboardData(currentData);
  };

  const uploadDocument = async () => {
    let docId = null;
    showLoader();
    try {
      let param = {
        DocumentName: chqName,
        DocumentType: chqName.split(".").pop(),
        DocumentUrl: "",
        BinaryFile: binaryDataChq,
        //  IsActive: true
      };
      const insertData = await APICall(documentDetails, param);
      if (insertData.Status === ApiStatus.OK && insertData?.Data) {
        docId = insertData.Data;
      } else {
        notify(ToastType.Error, insertData?.Message || "Failed to upload document, Please try again later.");
      }
    } finally {
    }
    hideLoader();
    return docId;
  };

  const addDataToGrid = async () => {
    let formErrorObj = onSubmitValidation();
    let isEmpty = Object.values(formErrorObj).every((f) => {
      return f === "" || f === null || f === undefined;
    });

    if (isEmpty) {
      const sum = dashboardData.reduce((total, currentItem) => parseFloat(total) + parseFloat(currentItem.Amount), 0) + parseFloat(Amount);
      if (sum > RepaymentAmount) {
        notify(ToastType.Error, "You have reached the limit cannot add more");
        return;
      }

      let docId = null;
      if (!chequeDocId && chequeDocId == null) {
        if (transcType?.label?.toLowerCase() === "cheque".toLowerCase()) {
          docId = await uploadDocument();
          if (docId === null) {
            return;
          }
        }
      } else {
        docId = chequeDocId;
      }

      let newData: DashboardDataItem = {
        AccountHolderName: AccHolderName,
        BankName: bankName?.SystemName?.toLowerCase() === "other" ? bankNameTxt : bankName?.label,
        BankID: bankName.value,
        Amount: Amount,
        TransactionDate: moment(transcDate).toDate(),
        TransactionRefNumber: transctRefNumber,
        TypesOfTransactionName: transcType?.label,
        TypesOfTransactionId: transcType?.value,
        StatusTitle: "Active",
        ChequeDocId: docId,
        ChequeName: chqName,
        Branch: branchName,
        Id: id || "",
        IsActive: true,
      };

      setDashboardData([...dashboardData, newData]);
      onClear();

      setIsDataEdited(false);
    }
  };

  const submitData = async () => {
    const sum = dashboardData.reduce((total, currentItem) => parseFloat(total) + parseFloat(currentItem.Amount), 0);

    if (parseInt(sum) != parseInt(RepaymentAmount)) {
      notify(
        ToastType.Error,
        `Total amount mismatch${` by -₹${getFormattedCurrencyValue(`${parseInt(RepaymentAmount) - parseInt(sum)}`)}`}, Please add valid payment details.`
      );
      return;
    }

    let tempData = [...dashboardData];

    let arr = [];

    // dashboardOverallData.forEach((item) => {
    //   const exists = tempData.some((elem) =>
    //     elem.Id != "" && elem.Id != null ? elem.Id == item.Id : null
    //   );

    //   if (!exists && exists != null) {
    //     tempData.push({ ...item, IsActive: false });
    //   }
    // });

    for (let i = 0; i < tempData.length; i++) {
      const item = tempData[i];


      arr.push({
        LoanRepaymentId: LoanRepaymentId,
        AccountHolderName: item.AccountHolderName,
        BankName: item.BankName,
        BankID: item.BankID,
        TransactionRefNo: item.TransactionRefNumber,
        Amount: item.Amount,
        TypesOfTransactionId: item.TypesOfTransactionId,
        IFSCCode: item.Branch,
        ChequeDocumentID: item.ChequeDocId,
        TransactionDate: item.TransactionDate,
        UserId: context.Id,
        Id: item?.Id || 0,
        IsActive: item.IsActive,
      });
    }

    const requestData = {
      Payments: arr,
    };


    const resp = await APICall(InsertLoanRepaymentPaymentDetails, requestData);

    if (resp.Status === ApiStatus.OK && resp.Data) {
      notify(ToastType.Success, "Loan repayment payment request submitted successfully.");
      navigate(-1);
    } else {
      notify(ToastType.Error, "Loan repayment payment request submittion failed. Please Contact Administrator");
    }
  };

  const GetAllPaymentDetails = async () => {
    try {
      showLoader();
      const requestData = {
        LoanRepaymentId: LoanRepaymentId,
      };

      const resp = await APICall(GetLoanRepaymentPaymentDetails, requestData);

      if (resp.Status === ApiStatus.OK && resp.Data?.length > 0) {
        let newDashboardData = [];

        for (let i = 0; i < resp?.Data?.length; i++) {
          const item = resp?.Data?.[i];

          newDashboardData.push({
            AccountHolderName: item.AccountHolderName,
            BankName: item.DisplayBankName,
            BankID: item.BankID,
            Amount: item.Amount,
            TransactionDate: item.TransactionDate,
            TransactionRefNumber: item.TransactionRefNo,
            TypesOfTransactionName: item.TypesOfTransactionName,
            TypesOfTransactionId: item.TypesOfTransactionId,
            StatusTitle: "",
            Branch: item.IFSCCode,
            Id: item.Id,
            ChequeDocId: item.ChequeDocumentID,
            ChequeDocUrl: item?.ChequeDocUrl ? await downloadBlob(item.ChequeDocUrl) : null,
            ChequeName: item?.ChequeDocName,
            IsActive: item.IsActive,
          });

          setbankNameTxt(item.DisplayBankName);

          setchqName(item?.ChequeDocName);
        }
        // let tempData = [];
        // for (let i = 0; i < newDashboardData.length; i++) {
        //   const item = newDashboardData[i];
        //   tempData.push({
        //     src: item?.ChequeDocUrl,
        //     title: "Cheque of Ref no. " + item.TransactionRefNumber,
        //   });
        // }

        // setImages(tempData);

        setImages(
          newDashboardData
            .filter((ndd) => ndd?.ChequeDocUrl)
            .map((ndd) => ({
              src: ndd?.ChequeDocUrl,
              title: "Cheque of Ref no. " + ndd.TransactionRefNumber,
              docId: ndd.ChequeDocId,
            }))
        );
        setDashboardData(newDashboardData);
        setDashboardOverallData(newDashboardData);
      }
    } finally {
      hideLoader();
    }
  };

  const handleTextEvent = async (event: any, field: any) => {
    let value = event.target.value;

    if (field === "Name") {
      setAccHolderName(value);
    }
    if (field === "bankName") {
      setbankNameTxt(value);
    }

    if (field === "amount") {
      setAmount(value);
    }
    if (field === "refNumber") {
      settransctRefNumber(value);
    }
    if (field === "branchName") {
      setBranchName(value);
    }
  };

  const onChangeUploadCheque = async (key, value) => {
    if (key == "uploadCheque" && value.target.files.length > 0) {
      setChequeDocUrl(null);
      setChequeDocId(null);
      let errormessage = "chqError";
      let e = value.target.files[0].name;
      let file = value.target.files[0];
      let extension = ["jpeg", "png", "jpg", "pdf"];
      let validfile = e.split(".").pop();
      setchqName(e);
      if (!extension.includes(validfile)) {
        await setError({
          ...error,
          [errormessage]: "File should be only jpeg or png or pdf",
        });
        value = file.name;
      } else if (file.size / 1024 / 1024 > 2) {
        await setError({
          ...error,
          [errormessage]: "Please select file size upto 2mb",
        });
        value = file.name;
      } else {
        await setError({
          ...error,
          [errormessage]: "",
        });
        let tempString = await getBase64FromFilePromise(file);
        let fileBase64 = "";
        if (tempString && tempString !== "") {
          fileBase64 = String(tempString).split("base64,")[1];
        }
        setBinaryChq(fileBase64);
        value = fileBase64;
      }
    }
    // await setData({ ...data, [key]: value });
  };

  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "transacType") {
      setTranscType(event);
      setIsChecked(event?.label?.toLowerCase() === "Cheque"?.toLowerCase());
    }
    if (apiFieldName === "transacDate") {
      setTranscDate(event);
    }
    if (apiFieldName === "bankName") {
      setbankName(event);
      const isOther = event?.SystemName?.toLowerCase() === "other";
      if (!isOther) {
        setbankNameTxt("");
      }
      setBankAsText(isOther);
    }
  };
  const onClear = () => {
    setAccHolderName("");
    setbankName(null);
    settransctRefNumber("");
    setTranscType(null);
    setTranscDate(null);
    // settransacTypeOption(null);
    setIsChecked(false);
    setAmount("");
    setBranchName("");
    setBankAsText(false);
    setbankNameTxt("");
    setchqName(null);
    setChequeDocUrl(null);
    setChequeDocId(null);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const isFile = (input: any) => "File" in window && input instanceof File;

  const dashboardOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    // count: count,
    // rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    // customSearchRender: debounceSearchRender(500),

    textLabels: {
      body: {
        noMatch: "No data found",
      },
    },
  };

  const dashboardGridColumns = [
    //0
    {
      name: "Id",
      label: "ID",
      options: {
        display: false,
      },
    },

    //1
    {
      name: "AccountHolderName",
      label: "Account Holder Name",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography
                  // fontFamily={"Georama-Regular"}
                  fontSize={"14px"}
                  component={"span"}
                  noWrap={true}
                >
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },

    //2
    {
      name: "BankName",
      label: "Bank Name",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography
                  // fontFamily={"Georama-Regular"}
                  fontSize={"14px"}
                  component={"span"}
                  noWrap={true}
                >
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },
    // application Date - pending
    //3
    {
      name: "TransactionDate",
      label: "Transaction Date",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography
                  // fontFamily={"Georama-Regular"}
                  fontSize={"14px"}
                  component={"span"}
                  noWrap={true}
                >
                  {value ? moment(value).format(DATE_DISPLAY_FORMAT) : ""}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },

    //4
    {
      name: "TransactionRefNumber",
      label: "Transaction Reference Number",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        display: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography
                  // fontFamily={"Georama-Regular"}
                  fontSize={"14px"}
                  component={"span"}
                  noWrap={true}
                >
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },

    //5
    {
      name: "Amount",
      label: "Amount",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        display: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography
                  // fontFamily={"Georama-Regular"}
                  fontSize={"14px"}
                  component={"span"}
                  noWrap={true}
                >
                  {getFormattedCurrencyValueWithSymbol(value)}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },

    //6
    {
      name: "TypesOfTransactionName",
      label: "Transaction Type",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: false,
        display: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography
                  // fontFamily={"Georama-Regular"}
                  fontSize={"14px"}
                  component={"span"}
                  noWrap={true}
                >
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },
    //7
    {
      name: "ChequeDocUrl",
      label: "ChequeDocUrl",
      options: {
        display: false,
      },
    },
    //8
    {
      name: "Id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        display: true,
        setCellProps: () => ({
          style: { minWidth: "120px", maxWidth: "120px" },
        }),
        customBodyRender: (value, tableMeta) => {
          let rowIndex = tableMeta.rowIndex;
          let id = tableMeta.tableData[rowIndex][0];
          let ChequeDocUrl = tableMeta.tableData[rowIndex][7];

          if (!disable) {
            return (
              <>
                <Tooltip title="edit" className="ml-2">
                  <a
                    onClick={(e) => {
                      if (isDataEdited) {
                        notify(ToastType.Error, `Please save the existing data first`);
                      } else {
                        e.preventDefault();
                        setId(dashboardData[tableMeta.rowIndex].Id);
                        setAccHolderName(dashboardData[tableMeta.rowIndex].AccountHolderName);
                        const bank = bankArray.find((b) => b.value == dashboardData[tableMeta.rowIndex].BankID);
                        setbankName(bank);
                        const isOther = bank?.SystemName?.toLowerCase() === "other";
                        if (!isOther) {
                          setbankNameTxt("");
                        } else {
                          setbankNameTxt(dashboardData[tableMeta.rowIndex].BankName);
                        }
                        setBankAsText(isOther);
                        settransctRefNumber(dashboardData[tableMeta.rowIndex].TransactionRefNumber);
                        setAmount(dashboardData[tableMeta.rowIndex].Amount);
                        setTranscDate(dashboardData[tableMeta.rowIndex].TransactionDate);
                        const transType = transArray.find((t) => t.Id == dashboardData[tableMeta.rowIndex].TypesOfTransactionId);
                        setTranscType(transType);
                        setIsChecked(transType?.label?.toLowerCase() === "Cheque"?.toLowerCase());
                        setBranchName(dashboardData[tableMeta.rowIndex].Branch);
                        setchqName(dashboardData[tableMeta.rowIndex].ChequeName);
                        setChequeDocUrl(dashboardData[tableMeta.rowIndex].ChequeDocUrl);
                        for (let i = 0; i < images.length; i++) {
                          const element = images[i];

                          if (element.docId == dashboardData[tableMeta.rowIndex].ChequeDocId) {
                            setChequeDocId(i);
                          }
                        }
                        // setChequeDocId(
                        //   dashboardData[tableMeta.rowIndex].ChequeDocId
                        // );
                        setShowFields(true);
                        setTableRowIndex(tableMeta.rowIndex);
                        removeRow(tableMeta.rowIndex);

                        setIsDataEdited(true);
                      }
                    }}
                  >
                    <i className="fas fa-edit"></i>
                    {/* <i className="fa fa-pencil"></i> */}
                  </a>
                </Tooltip>
                <Tooltip title="Delete" className="ml-2">
                  <a
                    onClick={(e) => {
                      if (isDataEdited) {
                        notify(ToastType.Error, `Please save the existing data first`);
                      } else {
                        e.preventDefault();
                        let tempData = images;
                        if (tempData.length > 0) {
                          for (let i = 0; i < tempData.length; i++) {
                            const element = tempData[i];

                            if (element.docId == dashboardData[tableMeta.rowIndex].ChequeDocId) {
                              tempData.slice(i, 1);
                            }
                          }
                        }
                        setImages(tempData);
                        removeRow(tableMeta.rowIndex);
                      }
                    }}
                  >
                    <i className="fa fa-trash"></i>
                  </a>
                </Tooltip>
                {/* {ChequeDocUrl && (
                  <Tooltip title="View cheque" className="ml-2">
                    <a
                      onClick={(e) => {
                        if (isDataEdited) {
                          notify(
                            ToastType.Error,
                            `Please save the existing data first`
                          );
                        } else {
                          e.preventDefault();
                          setImageIndex(rowIndex);
                        }
                      }}
                    >
                      <i className="fa fa-image"></i>
                    </a>
                  </Tooltip>
                )} */}
              </>
            );
          } else {
            return (
              <>
                <Tooltip title="view">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      setId(dashboardData[tableMeta.rowIndex].Id);
                      setAccHolderName(dashboardData[tableMeta.rowIndex].AccountHolderName);
                      const bank = bankArray.find((b) => b.value == dashboardData[tableMeta.rowIndex].BankID);
                      setbankName(bank);
                      const isOther = bank?.SystemName?.toLowerCase() === "other";
                      if (!isOther) {
                        setbankNameTxt("");
                      } else {
                        setbankNameTxt(dashboardData[tableMeta.rowIndex].BankName);
                      }
                      setBankAsText(isOther);
                      settransctRefNumber(dashboardData[tableMeta.rowIndex].TransactionRefNumber);
                      setAmount(dashboardData[tableMeta.rowIndex].Amount);
                      setTranscDate(dashboardData[tableMeta.rowIndex].TransactionDate);
                      const transType = transArray.find((t) => t.Id == dashboardData[tableMeta.rowIndex].TypesOfTransactionId);
                      setTranscType(transType);
                      setIsChecked(transType?.label?.toLowerCase() === "Cheque"?.toLowerCase());
                      setBranchName(dashboardData[tableMeta.rowIndex].Branch);
                      setchqName(dashboardData[tableMeta.rowIndex].ChequeName);
                      setChequeDocUrl(dashboardData[tableMeta.rowIndex].ChequeDocUrl);
                      // images.find((im) => {
                      //   return (
                      //     im.docId ==
                      //     dashboardData[tableMeta.rowIndex].ChequeDocId
                      //   );
                      // });
                      for (let i = 0; i < images.length; i++) {
                        const element = images[i];

                        if (element.docId == dashboardData[tableMeta.rowIndex].ChequeDocId) {
                          setChequeDocId(i);
                        }
                      }
                      // setChequeDocId(
                      //   dashboardData[tableMeta.rowIndex].ChequeDocId
                      // );
                      setTableRowIndex(tableMeta.rowIndex);
                      setShowFields(true);
                      // removeRow(tableMeta.rowIndex);
                    }}
                  >
                    <i className="fas fa-eye"></i>
                  </a>
                </Tooltip>
                {/* {ChequeDocUrl && (
                  <Tooltip title="View cheque" className="ml-2">
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        setImageIndex(rowIndex);
                      }}
                    >
                      <i className="fa fa-image"></i>
                    </a>
                  </Tooltip>
                )} */}
              </>
            );
          }
        },
      },
    },
  ];

  const handleClickEvent = () => {
    if (isDataEdited) {
      notify(ToastType.Error, `Please save the existing data first`);
    } else {
      setShowFields(!showFields);

      if (showFields == false) {
        onClear();
      }
    }
  };

  const getConfigData = async () => {
    let temp = bankDetails.map((bd) => bd.name); //["accountname", "accountnumber", "bankname", "ifsccode"];
    let arr = [];
    let param = `${getConfigValues}`;
    const getdata = await APICall(param, { Keys: temp });
    arr = getdata.Data ? getdata.Data?.map((c) => c?.Value) : [];
    if (getdata.Status === ApiStatus.OK && getdata?.Data?.length > 0) {
      const confData = getdata?.Data;
      const updatedBankDetails = bankDetails.map((detail) => {
        const configItem = confData.find((config) => config.Key === detail.name);
        return {
          ...detail,
          value: configItem ? configItem.Value : detail.value,
        };
      });
      setBankDetails(updatedBankDetails);
    }
  };

  useEffect(() => {
    if (imageIndex !== null) {
      setShowImageViewer(true);
    }
  }, [imageIndex]);

  useEffect(() => {
    if (!showImageViewer) {
      setImageIndex(null);
    }
  }, [showImageViewer]);

  useEffect(() => {
    getConfigData();
    getTransDropDownDataApiCall();
    getDropDownDataBankDetail();
    if (disable || Status === LoanRepayment.LoanRepayment_InternalTeamPaymentDetailsRequestSentBack) {
      GetAllPaymentDetails();
    }
  }, []);

  return (
    <div>
      <div className="">
        <div className="col-12">
          {!disable && (
            <div
              className=""
              style={{
                textAlign: "center",
                fontWeight: "bold",
                background: "#F6ECED",
                padding: "15px",
                margin: "10px 0",
              }}
            >
              <div className="my-2 table-bank-details-head">
                Please send the entered amount {RepaymentAmount && getFormattedCurrencyValueWithSymbol(RepaymentAmount)} on the following bank details.
              </div>
              <Table borderless hover size="sm" className="d-flex justify-content-center">
                <tbody>
                  {bankDetails.map((bd) => {
                    return (
                      <tr>
                        <td className="text-right">
                          <span className="table-bank-details-data" style={{ fontSize: "14px" }}>
                            {bd.label}
                          </span>
                        </td>
                        <td>:</td>
                        <td className="text-left">
                          <span className="table-bank-details-data" style={{ fontSize: "14px" }}>
                            {bd.value}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          )}
          <div className="">
            <>
              {!disable && (
                <div className="row mt-3">
                  <div className="p-2 d-flex justify-content-left" style={{ marginLeft: "7px" }}>
                    <ButtonComponent
                      icon={"fas fa-sharp fa-solid fa-plus"}
                      value={"Add payment details"}
                      id={"saveBtn"}
                      onClick={handleClickEvent}
                      disabled={disable}
                    />
                  </div>
                </div>
              )}
              <div>
                <div>
                  {/* <div className="row">
                  <div className="col-lg-2 col-md-6 col-sm-12">
                    <div className="form-group"></div>
                    <label>Account Holder Name:</label>
                  </div>
                  <div className="col-lg-4 col-md-8 col-sm-12">
                    <InputForm
                      placeholder={""}
                      value={AccHolderName}
                      maxLength={100}
                      onChange={(e) => handleTextEvent(e, "Name")}
                      textArea={false}
                      isDisabled={disable}
                    />
                    <p style={{ color: "red" }}>{formErrors["AccHolderName_isEmpty"]}</p>
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12">
                    <div className="form-group"></div>
                    <label>Bank Name:</label>
                  </div>
                  <div className="col-lg-4 col-md-8 col-sm-12">
                    <SelectForm
                      options={bankArray}
                      isMulti={false}
                      placeholder={""}
                      value={bankName}
                      isDisabled={disable}
                      onChange={(event: any) => selectOnChange(event, "bankName")}
                    />
                    {bankAsText ? (
                      <div className="mt-3 ">
                        <InputForm
                          placeholder={""}
                          value={bankNameTxt}
                          maxLength={100}
                          onChange={(e) => handleTextEvent(e, "bankName")}
                          textArea={false}
                          isDisabled={disable}
                        />
                        <p style={{ color: "red" }}>{formErrors["bankNameAsTxt_isEmpty"]}</p>
                      </div>
                    ) : null}
                    <p style={{ color: "red" }}>{formErrors["bankName_isEmpty"]}</p>
                  </div>
                </div>
                <div className="row mt-3 ">
                  <div className="col-lg-2 col-md-6 col-sm-12">
                    <div className="form-group"></div>
                    <label>Transaction Reference Number:</label>
                  </div>
                  <div className="col-lg-4 col-md-8 col-sm-12">
                    <InputForm
                      placeholder={""}
                      value={transctRefNumber}
                      maxLength={100}
                      onChange={(e) => handleTextEvent(e, "refNumber")}
                      textArea={false}
                      isDisabled={disable}
                    />
                    <p style={{ color: "red" }}>{formErrors["transctRefNumber_isEmpty"]}</p>
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12">
                    <div className="form-group"></div>
                    <label>Amount:</label>
                  </div>
                  <div className="col-lg-4 col-md-8 col-sm-12">
                    <InputForm
                      placeholder={""}
                      value={Amount}
                      maxLength={100}
                      onChange={(e) => handleTextEvent(e, "amount")}
                      textArea={false}
                      isDisabled={disable}
                      onKeyPress={(e) => handleKeyPress(e)}
                    />
                    <p style={{ color: "red" }}>{formErrors["Amount_isEmpty"]}</p>
                  </div>
                </div>
                <div className="row mt-3 ">
                  <div className="col-lg-2 col-md-6 col-sm-12">
                    <div className="form-group"></div>
                    <label>Type of Transaction:</label>
                  </div>
                  <div className="col-lg-4 col-md-8 col-sm-12">
                    <SelectForm
                      options={transArray}
                      // options={transacTypeOption.map(option => ({ value: option, label: option }))}
                      isMulti={false}
                      placeholder={""}
                      value={transcType}
                      isDisabled={disable}
                      onChange={(event: any) => selectOnChange(event, "transacType")}
                    />
                    <p style={{ color: "red" }}>{formErrors["transcType_isEmpty"]}</p>
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12">
                    <div className="form-group"></div>
                    <label>Transaction Date:</label>
                  </div>
                  <div className="col-lg-4 col-md-8 col-sm-12">
                    <DateForm
                      disableFuture={true}
                      // isDisabled={false}
                      value={transcDate}
                      onChange={(event: any) => selectOnChange(event, "transacDate")}
                      placeholder="DD-MM-YYYY"
                      isDisabled={disable}
                    />
                    <p style={{ color: "red" }}>{formErrors["transcDate_isEmpty"]}</p>
                  </div>
                </div>
                <div className="row mt-3">
                  {isChecked ? (
                    <>
                      <div className="col-lg-2 col-md-6 col-sm-12">
                        <div className="form-group"></div>
                        <label>Upload Cheque:</label>
                      </div>
                      <div className="col-lg-4 col-md-8 col-sm-12">
                        <input
                          autoComplete={AutoCompleteValue}
                          name="file-8[]"
                          id="file-8-chque"
                          className="form-control inputfile inputfile-6"
                          onChange={(e) => onChangeUploadCheque("uploadCheque", e)}
                          type="file"
                          disabled={false}
                        />
                        <label htmlFor="file-8-chque" className="form-control" style={{ border: "none" }}>
                          <span style={{ float: "right" }}>{chqName}</span>
                          <strong
                            style={{
                              width: "30%",
                              left: "0",
                              borderTopRightRadius: "0",
                              borderBottomRightRadius: "0",
                            }}
                          >
                           <i className="far fa-file"></i> Browse
                          </strong>
                        </label>
                        <div>
                          <p style={{ fontSize: "11px" }}> File extension should be jpg, png and pdf</p>
                        </div>
                      </div>
                    </>
                  ) : null}
                  <div className="col-lg-2 col-md-6 col-sm-12">
                    <div className="form-group"></div>
                    <label>Branch:</label>
                  </div>
                  <div className="col-lg-4 col-md-8 col-sm-12">
                    <InputForm
                      placeholder={""}
                      value={branchName}
                      maxLength={100}
                      onChange={(e) => handleTextEvent(e, "branchName")}
                      textArea={false}
                      isDisabled={disable}
                    />
                    <p style={{ color: "red" }}>{formErrors["branchName_isEmpty"]}</p>
                  </div>
                </div> */}
                </div>

                {showFields && (
                  <div>
                    <div className="row">
                      <div className="col-lg-4 col-sm-4 col-xs-4">
                        <div className="form-group">
                          <label>Account Holder Name</label>
                          <sup>*</sup>
                          <InputForm
                            placeholder={""}
                            value={AccHolderName}
                            maxLength={100}
                            onChange={(e) => handleTextEvent(e, "Name")}
                            textArea={false}
                            isDisabled={disable}
                            // onKeyPress={handleKeyNumbers}
                          />
                          {formErrors["AccHolderName_isEmpty"] && <p style={{ color: "red" }}>{formErrors["AccHolderName_isEmpty"]}</p>}
                        </div>
                      </div>
                      <div className={`col-lg-${bankAsText ? 2 : 4} col-sm-4 col-xs-4`}>
                        <div className="form-group">
                          <label>Bank Name</label>
                          <sup>*</sup>
                          <SelectForm
                            options={bankArray}
                            isMulti={false}
                            placeholder={""}
                            value={bankName}
                            isDisabled={disable}
                            onChange={(event: any) => selectOnChange(event, "bankName")}
                          />
                          <p style={{ color: "red" }}>{formErrors["bankName_isEmpty"]}</p>
                        </div>
                      </div>
                      {bankAsText && (
                        <div className={`col-lg-3 col-sm-4 col-xs-4`}>
                          <div className="form-group">
                            <label>Other Bank Name</label>
                            <sup>*</sup>
                            <InputForm
                              placeholder={""}
                              value={bankNameTxt}
                              maxLength={100}
                              onChange={(e) => handleTextEvent(e, "bankName")}
                              textArea={false}
                              isDisabled={disable}
                            />
                            <p style={{ color: "red" }}>{formErrors["bankNameAsTxt_isEmpty"]}</p>
                          </div>
                        </div>
                      )}
                      <div className={`col-lg-${bankAsText ? 3 : 4} col-sm-4 col-xs-4`}>
                        <div className="form-group">
                          <label>Transaction Reference Number</label>
                          <sup>*</sup>
                          <InputForm
                            placeholder={""}
                            value={transctRefNumber}
                            maxLength={100}
                            onChange={(e) => handleTextEvent(e, "refNumber")}
                            textArea={false}
                            isDisabled={disable}
                          />
                          <p style={{ color: "red" }}>{formErrors["transctRefNumber_isEmpty"]}</p>
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-4 col-xs-4">
                        <div className="form-group">
                          <label>Amount</label>
                          <sup>*</sup>
                          <InputForm
                            placeholder={""}
                            value={Amount}
                            maxLength={100}
                            onChange={(e) => handleTextEvent(e, "amount")}
                            textArea={false}
                            isDisabled={disable}
                            onKeyPress={(e) => handleKeyPress(e)}
                          />
                          <p style={{ color: "red" }}>{formErrors["Amount_isEmpty"]}</p>
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-4 col-xs-4">
                        <div className="form-group">
                          <label>Type of Transaction</label>
                          <sup>*</sup>
                          <SelectForm
                            options={transArray}
                            // options={transacTypeOption.map(option => ({ value: option, label: option }))}
                            isMulti={false}
                            placeholder={""}
                            value={transcType}
                            isDisabled={disable}
                            onChange={(event: any) => selectOnChange(event, "transacType")}
                          />
                          <p style={{ color: "red" }}>{formErrors["transcType_isEmpty"]}</p>
                        </div>
                      </div>
                      {isChecked && (
                        <div className="col-lg-2 col-sm-4 col-xs-4">
                          <div className="form-group">
                            <label>Upload Cheque</label>
                            <sup>*</sup>
                            {disable ? (
                              <div className="row justify-content-start">
                                <div className="col">
                                  <i className="fas fa-eye"></i>
                                </div>

                                <div className="col">
                                  {chequeDocUrl ? (
                                    <div>
                                      <a
                                        className="blue-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setImageIndex(chequeDocId);
                                        }}
                                      >
                                        {chqName}
                                      </a>
                                    </div>
                                  ) : (
                                    <span style={{ float: "right" }}>{chqName}</span>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div>
                                <div className="row justify-content-start align-items-center">
                                  <div className="col-auto">
                                    <input
                                      autoComplete={AutoCompleteValue}
                                      name="file-8[]"
                                      id="file-8-chque"
                                      className="form-control inputfile inputfile-6"
                                      onChange={(e) => onChangeUploadCheque("uploadCheque", e)}
                                      type="file"
                                      disabled={disable}
                                    />
                                    <label htmlFor="file-8-chque" className="form-control" style={{ border: "none" }}>
                                      <strong
                                        style={{
                                          width: "25%",
                                          left: "0",
                                          borderTopRightRadius: "0",
                                          borderBottomRightRadius: "0",
                                        }}
                                      >
                                        <i className="far fa-file"></i>
                                         {/* Browse */}
                                      </strong>
                                    </label>
                                  </div>

                                  <div className="col-auto">
                                    <i className="fa fa-image"></i>
                                  </div>
                                  <div className="col-auto">
                                    {chequeDocUrl ? (
                                      <div>
                                        <a
                                          className="blue-link"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setImageIndex(chequeDocId);
                                          }}
                                        >
                                          {chqName}
                                        </a>
                                      </div>
                                    ) : (
                                      <span style={{ float: "right" }}>{chqName}</span>
                                    )}
                                  </div>
                                </div>
                                <div>
                                  <p style={{ fontSize: "11px" }}> File extension should be jpg, png and pdf</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      <div className={`col-lg-${isChecked ? 2 : 4} col-sm-4 col-xs-4`}>
                        <div className="form-group">
                          <label>Transaction Date</label>
                          <sup>*</sup>
                          <DateForm
                            disableFuture={true}
                            // isDisabled={false}
                            value={transcDate}
                            onChange={(event: any) => selectOnChange(event, "transacDate")}
                            placeholder="DD-MM-YYYY"
                            isDisabled={disable}
                          />
                          <p style={{ color: "red" }}>{formErrors["transcDate_isEmpty"]}</p>
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-4 col-xs-4">
                        <div className="form-group">
                          <label>Branch</label>
                          <sup>*</sup>
                          <InputForm
                            placeholder={""}
                            value={branchName}
                            maxLength={100}
                            onChange={(e) => handleTextEvent(e, "branchName")}
                            textArea={false}
                            isDisabled={disable}
                          />
                          <p style={{ color: "red" }}>{formErrors["branchName_isEmpty"]}</p>
                        </div>
                      </div>
                    </div>

                    {!disable ? (
                      <div className="row justify-content-end mt-3">
                        <div className="d-flex justify-content-end">
                          <div style={{ marginRight: 10 }}>
                            <ButtonComponent
                              icon={"fa-solid fa-remove"}
                              value={"Clear"}
                              onClick={onClear}
                              // disabled={disableAllFields}
                            />
                          </div>
                          <ButtonComponent
                            icon={"fa-solid fa-floppy-disk"}
                            value={"Save"}
                            id={"saveBtn"}
                            onClick={() => addDataToGrid()}
                            // disabled={disableAllFields}
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
            </>

            <div className="row mt-3">
              <div className="col-lg-12 col-md-12 col-sm-12">
                {dashboardData && dashboardData.length >= 0 && (
                  <DynamicGrid options={dashboardOptions} data={dashboardData} columns={dashboardGridColumns} isDisabled={disable} />
                )}
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3" style={{ marginRight: "2rem" }}>
            {disable ? (
              <>
                <div>
                  <ButtonForm className="btn btn-submit" style={{ marginLeft: 5 }} id="Verify" value="Verify" onClick={(e) => setAnchorEl(e.currentTarget)} />
                </div>
              </>
            ) : (
              <div>
                <ButtonForm className="btn btn-submit" style={{ marginLeft: 5 }} id="submit" value="Submit" onClick={() => onClickFunction("Submit")} />
              </div>
            )}

            <div>
              <ButtonForm className="btn btn-cancel" id="cancel" style={{ marginLeft: 5 }} value="Cancel" onClick={() => onClickFunction("Cancel")} />
            </div>
          </div>
        </div>
      </div>

      <ImageViewer open={showImageViewer} images={images} imageIndex={imageIndex} onClose={() => setShowImageViewer(false)} />

      <LoanRepaymentVerifyModal
        open={showLoanRepaymentVerifyModal}
        anchorEl={anchorEl}
        handleClose={handleClose}
        LoanRepaymentId={LoanRepaymentId}
        module={VerifyModalModules.PaymentDetails}
      />
    </div>
  );
};

export default PaymentDetails;

function setImageIndex(chequeDocId: any) {
  throw new Error("Function not implemented.");
}
